//shivam shrivastava
import * as constants from "../constants/CONSTANT";
import helper from "../components/common/helper";

const ChatBotflowApi = {
  async fetchChatbotFlows(businessNumber) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow?business_number=${businessNumber}`,
      "GET"
    );
    const data = await response.json();
    return data;
  },
  //create chatbot flow
  async createChatbotFlow(flowData) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow`,
      "POST",
      JSON.stringify(flowData)
    );
    const data = await response.json();
    return data;
  },

  async updateChatbotFlow(flowId, flowData) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow/${flowId}`,
      "PUT",
      JSON.stringify(flowData)
    );
    const data = await response.json();
    return data;
  },

  async deleteChatbotFlow(flowId) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow/${flowId}`,
      "DELETE"
    );
    const data = await response.json();
    return data;
  },

  async getActiveChatbotFlows(businessNumber) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow/active/${businessNumber}`,
      "GET"
    );
    const data = await response.json();
    return data;
  },

  async updateFlowStatus(flowId, status) {
    const response = await helper.fetchWithAuth(
      `${constants.API_BASE_URL}/api/whatsapp/chatbotflow/${flowId}/status`,
      "PATCH",
      JSON.stringify({ status })
    );
    const data = await response.json();
    return data;
  },
};

export default ChatBotflowApi;
